import { useEffect } from "react"
import { useRouter } from "next/router"
import { initGoogleTagManager } from "@/lib/google-tag-manager"
import { useAppContext } from "@/lib/contexts/appContext"
import { fetchPathData } from "@/lib/api/pathData"
import { Layout } from "@/components/base/layout"
import Head from "@/lib/head"

const Index = ({ pathData }) => {
  const { meta, resetAppContext } = useAppContext()
  const { locale } = useRouter()

  useEffect(() => {
    const { gtmContainerId } = meta
    if (gtmContainerId) {
      initGoogleTagManager(gtmContainerId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    resetAppContext()

    const nextRoute = {
      event: "nextRoute",
      locale: locale,
      path: "/" + locale + pathData.path.replace("/bra-miljoval", "") || "/"
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(nextRoute)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathData])

  return (
    <>
      <Head />
      <Layout />
    </>
  )
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking"
  }
}

export async function getStaticProps(context) {
  let slugs = context.params?.slug

  if (slugs && slugs[0] === "index") {
    slugs = []
  }

  const path = slugs?.length ? "/" + slugs.join("/") + "/" : "/"

  if (context.preview) {
    return {
      redirect: {
        destination: "/api/stopPreviewSession" + path
      },
      revalidate: 1
    }
  }

  try {
    const pathData = await fetchPathData({
      path,
      isPreview: context.preview && path === context?.previewData?.path,
      locale: context?.locale
    })

    if (!pathData) {
      throw new Error("API response error")
    }

    if (pathData.status === 404) {
      return {
        notFound: true,
        revalidate: 60
      }
    }

    if (pathData.redirect) {
      return {
        redirect: {
          destination: pathData.path,
          permanent: [301, 308].includes(pathData.status)
        },
        revalidate: 60
      }
    }

    return {
      props: { pathData },
      revalidate: 60
    }
  } catch (error) {
    throw new Error("Internal error")
  }
}

export default Index
